import React from "react";
import { Permission } from "./PermissionProvider";

interface PermissionContextType {
	isAllowedTo: (permission: Permission) => boolean;
}

//Reject admission when use outside of provicer
const defaultBehaviour: PermissionContextType = {
	isAllowedTo: () => false,
};

// Create the context
const PermissionContext =
	React.createContext<PermissionContextType>(defaultBehaviour);

export default PermissionContext;
